import { axiosAuth } from "../../config/axiosInstances";

export function askUserDoubt(
  lesson_id,
  query,
  is_voice,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/doubt_solver",
        {
          lesson_id,
          query,
          is_voice,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserChatHistory(lesson_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/doubt_solver/chat_history",
        {
          params: {
            lesson_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserDoubtAudio(uai, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/doubt_solver/audio_file",
        {
          params: {
            uai,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function getOtherLearnerDoubts(lesson_id, page, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/doubt_solver/asked_doubts",
        {
          params: {
            lesson_id,
            page
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}
